import React, {useMemo} from 'react'
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import $ from 'jquery'

import {addManualCalculateRow, toggleShowManualCalculation} from "../../../../actions/sqftManualCalculationFunctions";
import ManualCalculateSwitcher from "../navigation/menuSwitchers/ManualCalculateSwitcher";
import SqftCountertopRow from "./SqftCountertopRow";
import SqftEdgeRow from "./SqftEdgeRow";
import SqftBacksplashRow from "./SqftBacksplashRow";
import {numToLetter} from "../../helpers/sqftHelper";
import {MANUAL_CALCULATION_ROW_TYPES, SQFT_FEATURES} from "../../constants";
import {
  manualCalculationsBacksplashArea,
  manualCalculationsCountertopArea,
  manualCalculationsEdgesLength
} from "../../helpers/sqftCalculations";
import {updateSQFTCalculations} from "../../../../actions/sqftFunctions";
import SqftFooterAddToQuoteButton from "../SqftFooterAddToQuoteButton";
import SqftFooterCancelButton from "../SqftFooterCancelButton";
import useFetchFeatures from "../../hocs/useFetchFeatures";

const SqftManualCalculateWindow = (props) => {
  const {showManualCalculation, addManualCalculateRow, countertopRows, backsplashRows, edgeRows} = props;

  const partIds = useMemo(() => {
    if (!showManualCalculation) return [];
    return [SQFT_FEATURES.edge_profile, SQFT_FEATURES.center_island_edge];
  }, [showManualCalculation]);

  const { featuresData, isLoading } = useFetchFeatures(partIds);

  const shouldDisplayEdgeColumn = useMemo(() => {
    if (!showManualCalculation) return false;

    // Keep the column visible while loading to avoid layout jump
    if (isLoading) return true;

    const main = featuresData?.[SQFT_FEATURES.edge_profile];
    const opposite = featuresData?.[SQFT_FEATURES.center_island_edge];

    const mainHasAny = !!(main?.allNavItems?.length);
    const oppositeHasAny = !!(opposite?.allNavItems?.length);

    return mainHasAny || oppositeHasAny;
  }, [featuresData, isLoading, showManualCalculation]);

  const handleAddRow = (type) => {
    addManualCalculateRow(type);
    scrollTo('#' + type +' .drop-down-ul');
  };

  const scrollTo = ($selector) => {
    const dropDownUl = $($selector);
    if (!dropDownUl.length || !dropDownUl[0]) {
      return;
    }
    dropDownUl.animate({scrollTop: dropDownUl[0].scrollHeight }, 'slow');
  };

  return (
    <div className={"manual-overlay " + (showManualCalculation ? "manual-overlay--visible" : "")} id='manual-calculate-container'>
      <div className="manual-overlay-logo">
        <ManualCalculateSwitcher overlay={true}/>
        <div className="manual-window">
          <h2 className="manual-window-title" data-text="sqft.manual.title">
            <FormattedMessage id={"sqft.manual.title"}/>
          </h2>
          <div className="manual-window-content">

            <div className="manual-header row">
            </div>

            <div className="manual-content row">
              <div id={MANUAL_CALCULATION_ROW_TYPES.countertopRows} className="container-fluid col-xs-4">
                <div className="manual-column__header">
                  <div className="col-xs-4 manual-column__title">
                    <div className="" data-text="sqft.manual.title.countertop">
                      <FormattedMessage id={"sqft.manual.title.countertop"}/>
                    </div>
                    <div className="manual-column__total">
                      <span className="text" data-text="sqft.manual.title.total">
                        <FormattedMessage id={"sqft.manual.title.total"}/>:
                      </span>
                      <span className="value" data-content="total-countertop-value">
                        {manualCalculationsCountertopArea()}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="manual-column__content">
                  <div className="row header">
                    <div className="col-xs-2"/>
                    <div className="col-xs-4" data-text="sqft.manual.column.length">
                      <FormattedMessage id={"sqft.manual.column.length"}/>
                    </div>
                    <div className="col-xs-2"/>
                    <div className="col-xs-4" data-text="sqft.manual.column.width">
                      <FormattedMessage id={"sqft.manual.column.width"}/>
                    </div>
                    <div className="col-xs-2"/>
                  </div>

                  <div className="drop-down-ul">
                    {countertopRows.map((row, index) => {
                      const rowLetter = numToLetter(index + 1);
                      return (
                        <SqftCountertopRow
                          row={row}
                          rowIndex={index + 1}
                          rowLetter={rowLetter}
                          key={index + 1}
                        />
                      );
                    })}
                  </div>

                  <div className="manual-add" onClick={() => handleAddRow(MANUAL_CALCULATION_ROW_TYPES.countertopRows)}>
                    <span
                      className='add-entry-btn no-user-select'
                      data-text="sqft.manual.buttonAddEntry"
                      data-type="countertops"
                    >
                      <FormattedMessage id={"sqft.manual.buttonAddEntry"}/>
                    </span>
                  </div>
                </div>
              </div>

              {shouldDisplayEdgeColumn ? (
                <div id={MANUAL_CALCULATION_ROW_TYPES.edgeRows} className="container-fluid col-xs-4">
                  <div className="manual-column__header">
                    <div className="col-xs-4 manual-column__title">
                      <div className="" data-text="sqft.manual.title.edge">
                        <FormattedMessage id={"sqft.manual.title.edge"}/>
                      </div>
                      <div className="manual-column__total">
                        <span className="text" data-text="sqft.manual.title.total">
                          <FormattedMessage id={"sqft.manual.title.total"}/>:
                        </span>
                        <span className="value" data-content="total-edge-value">
                          {manualCalculationsEdgesLength()}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="manual-column__content">
                    <div className="row header header3">
                      <div className="col-xs-2"/>
                      <div className="col-xs-4" data-text="sqft.manual.column.length">
                        <FormattedMessage id={"sqft.manual.column.length"}/>
                      </div>
                      <div className="col-xs-4" data-text="sqft.manual.column.height">
                        <FormattedMessage id={"sqft.manual.column.height"}/>
                      </div>
                      <div className="col-xs-4" data-text="sqft.manual.column.type">
                        <FormattedMessage id={"sqft.manual.column.type"}/>
                      </div>
                      <div className="col-xs-2"/>
                    </div>

                    <div className="drop-down-ul">
                      {edgeRows.map((row, index) => {
                        const rowLetter = numToLetter(index + 1);
                        return (
                          <SqftEdgeRow
                            row={row}
                            rowIndex={index + 1}
                            rowLetter={rowLetter}
                            key={index + 1}
                          />
                        );
                      })}
                    </div>

                    <div className="manual-add" onClick={() => handleAddRow(MANUAL_CALCULATION_ROW_TYPES.edgeRows)}>
                      <span
                        className='add-entry-btn no-user-select'
                        data-text="sqft.manual.buttonAddEntry"
                        data-type="edges"
                      >
                        <FormattedMessage id={"sqft.manual.buttonAddEntry"}/>
                      </span>
                    </div>
                  </div>
                </div>
              ) : null}

              <div id={MANUAL_CALCULATION_ROW_TYPES.backsplashRows} className="container-fluid col-xs-4">
                <div className="manual-column__header">
                  <div className="col-xs-4 manual-column__title">
                    <div className="" data-text="sqft.manual.title.backsplash">
                      <FormattedMessage id={"sqft.manual.title.backsplash"}/>
                    </div>
                    <div className="manual-column__total">
                      <span className="text" data-text="sqft.manual.title.total">
                        <FormattedMessage id={"sqft.manual.title.total"}/>:
                      </span>
                      <span className="value" data-content="total-backsplash-value">
                        {manualCalculationsBacksplashArea()}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="manual-column__content">
                  <div className="row header">
                    <div className="col-xs-2"/>
                    <div className="col-xs-4" data-text="sqft.manual.column.length">
                      <FormattedMessage id={"sqft.manual.column.length"}/>
                    </div>
                    <div className="col-xs-2"/>
                    <div className="col-xs-4" data-text="sqft.manual.column.height">
                      <FormattedMessage id={"sqft.manual.column.height"}/>
                    </div>
                    <div className="col-xs-2"/>
                  </div>

                  <div className="drop-down-ul">
                    {backsplashRows.map((row, index) => {
                      const rowLetter = numToLetter(index + 1);
                      return (
                        <SqftBacksplashRow
                          row={row}
                          rowIndex={index + 1}
                          rowLetter={rowLetter}
                          key={index + 1}
                        />
                      );
                    })}
                  </div>

                  <div className="manual-add" onClick={() => handleAddRow(MANUAL_CALCULATION_ROW_TYPES.backsplashRows)}>
                    <span
                      className='add-entry-btn no-user-select'
                      data-text="sqft.manual.buttonAddEntry"
                      data-type="backsplashes"
                    >
                      <FormattedMessage id={"sqft.manual.buttonAddEntry"}/>
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div className="info-manual hide-desktop">
          <div className="info-manual-buttons">
            <SqftFooterCancelButton/>
            <SqftFooterAddToQuoteButton/>
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  countertopRows: store.sqftManualCalculationState.countertopRows,
  backsplashRows: store.sqftManualCalculationState.backsplashRows,
  edgeRows: store.sqftManualCalculationState.edgeRows,
  showManualCalculation: store.sqftManualCalculationState.showManualCalculation,
  updateCalculations: store.sqftState.updateCalculations,
});

const mapDispatchToProps = {
  toggleShowManualCalculation,
  addManualCalculateRow,
  updateSQFTCalculations
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftManualCalculateWindow);
